import { CeruleanButton } from 'components/Button'
import Column from 'components/Column'
import Currency from 'components/Currency'
import I18n from 'components/I18n'
import Row from 'components/Row'
import Text from 'components/Text'
import { actions } from 'data'
import { ModalOrigin } from 'data/types'
import messages from 'lang'
import React from 'react'
import { connect, ConnectedProps } from 'react-redux'
import styled from 'styled-components'
import { color } from 'utils'

const Copy = styled(Text)`
  margin: 0.5rem 0 1rem 0;
`

const StyledRow = styled(Row)`
  border: 1px solid ${color('dark400')};
  margin: 1rem;
  border-radius: 0.5rem;
  padding: 1rem 1.5rem;
`

type Props = {
  currency: string
} & ConnectedProps<typeof connector>

const Empty = ({ currency, showDepositModal }: Props) => (
  <StyledRow>
    <Column alignItems='center' grow={1}>
      <Text color='white' size='xl' weight={600}>
        <I18n crypto={<Currency code={currency} />} data={messages.no_balance} />
      </Text>
      <Copy color='dark300' size='md' weight={600}>
        <I18n data={messages.click_below_button} />
      </Copy>
      <CeruleanButton e2e='depositButton' onClick={showDepositModal}>
        <I18n data={messages.button_deposit} />
      </CeruleanButton>
    </Column>
  </StyledRow>
)

const mapDispatchToProps = (dispatch) => ({
  showDepositModal: () => {
    dispatch(
      actions.analytics.trackEvent({
        key: 'Deposit Clicked',
        properties: {
          origin: 'WITHDRAW'
        }
      })
    )
    dispatch(actions.deposit.open({ origin: ModalOrigin.NO_FUNDS }))
  }
})

const connector = connect(null, mapDispatchToProps)
export default connector(Empty)
